module.exports = __webpack_public_path__ + "img/yszc-gszc-guide.b41f642f.png";